/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { checkJarvisIsAdActive } from 'helpers/ads/utils';
// eslint-disable-next-line css-modules/no-unused-class
import s from './FlipCardAd.scss';
import { displayScorecardAd } from '../ScorecardWithAd/CriAdWidget';

const FlipCardAd = props => {
  // eslint-disable-next-line react/prop-types
  const {
    children,
    width,
    height,
    skipMwebAdSize,
    isFlipActive,
    isPrime,
    isMobile,
    msid,
  } = props;
  const [flipped, setflipped] = useState(false);
  const [adConfig, setAdsConfig] = useState(false);
  const [inView, setInView] = useState(false);
  const [maxFlipped, setMaxFlipped] = useState(0);

  const parentRef = useRef(null);
  let t1;
  let t2;

  const clearTimer = t => {
    if (t) {
      clearTimeout(t);
    }
  };

  const adCall = () => {
    const { adTimeout = 7, displayTimout = 1000, nextAdTimout = 10 } = adConfig;
    displayScorecardAd(
      r => {
        if (r) {
          clearTimer(t1);
          t1 = setTimeout(() => {
            setflipped(li => !li);
          }, displayTimout);
        } else {
          const nextt = nextAdTimout * 1000;
          clearTimer(t2);
          t2 = setTimeout(() => {
            setAdsConfig(li => ({ ...li, divId: li.divId + maxFlipped }));
            setMaxFlipped(li => li + 1);
          }, nextt);
          setflipped(false);
        }
      },
      adTimeout,
      adConfig,
    );
  };

  useEffect(
    () => {
      const maxAd = adConfig?.maxads || 50;
      if (inView && maxFlipped < maxAd && maxFlipped > 0) {
        adCall();
      }

      return () => {
        clearTimer(t1);
        clearTimer(t2);
      };
    },
    [maxFlipped, inView],
  );

  useEffect(
    () => {
      let elementObserver;
      if (adConfig) {
        const node = parentRef?.current;
        elementObserver = new IntersectionObserver(
          entries => {
            const [entry] = entries;
            const { isIntersecting } = entry;
            setInView(isIntersecting);
            if (isIntersecting) {
              setMaxFlipped(li => li + 1);
              // Stop observing
              if (
                node &&
                node instanceof HTMLElement &&
                elementObserver &&
                !maxFlipped
              ) {
                elementObserver.unobserve(node);
              }
            }
            return () => {
              if (node && node instanceof HTMLElement && elementObserver) {
                elementObserver.unobserve(node);
              }
            };
          },
          { rootMargin: '0px' },
        );
        if (node instanceof HTMLElement) {
          elementObserver.observe(node);
        }
      }
      return () => {
        if (elementObserver) {
          elementObserver.disconnect();
        }
      };
    },
    [adConfig],
  );

  useEffect(() => {
    let flipadconf = checkJarvisIsAdActive('scorecard_flip_ad');
    if (window.location.href.indexOf('test2=noflipad') > -1) {
      flipadconf = null;
    }
    if (flipadconf) {
      if (isMobile) {
        if (skipMwebAdSize) {
          flipadconf.adCode = flipadconf?.mweb?.adCode;
        } else {
          flipadconf = { ...flipadconf, ...flipadconf?.mweb };
        }
      }
      const adObj = {
        ...flipadconf,
        divId: `${flipadconf.divId}-${msid}`,
      };
      const startAfer = flipadconf.startAfer || 1;
      const t3 = setTimeout(() => {
        setAdsConfig(adObj);
        clearTimer(t3);
      }, startAfer * 1000);
    }
  }, []);

  const html = (
    <div className={s.wrapper} ref={parentRef}>
      {children}
    </div>
  );

  if (!adConfig || !isFlipActive || isPrime) {
    return children;
  }
  // UI Vars
  const cardStyle = { height, width };
  let container = `${s.card}`;
  container += window.App.state.isMobile ? ` ${s.upsidedown} ` : '';
  container += flipped ? ` ${s.flipped}` : '';
  return (
    <div className={container} style={cardStyle}>
      <div className={s.card_inner}>
        <div className={`${s.card_face} ${s.card_front}`}>{html}</div>
        <div className={`${s.card_face} ${s.card_back}`}>
          {adConfig && (
            <>
              <div className={s.close_ad} onClick={() => setflipped(false)} />
              <div
                id={adConfig.divId}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: '' }}
                suppressHydrationWarning
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

FlipCardAd.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  skipMwebAdSize: PropTypes.bool,
  isFlipActive: PropTypes.bool,
  isPrime: PropTypes.bool,
  children: PropTypes.node,
  isMobile: PropTypes.bool,
  msid: PropTypes.string,
};
FlipCardAd.defaultProps = {
  width: '300px',
  height: '114px',
  skipMwebAdSize: false,
  isFlipActive: false,
  isPrime: false,
  children: null,
  isMobile: false,
  msid: '',
};
const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isMobile: state.isMobile,
});
export default connect(mapStateToProps)(FlipCardAd);
